import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Widget } from '@src/shared/ui/components/Widget';
import { Skeleton } from '@src/shared/ui/components/Widget/components/Skeleton';
import { isEmpty } from 'lodash';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: UntrustedSources
 *
 * @TODO Needs description.
 *
 * @param data
 * @returns {Element}
 * @constructor
 */
export function UntrustedSources({ data = {} }) {
  return (
    <ErrorHandler location="src/widgets/RiskRecords/UntrustedSources/UntrustedSources.jsx">
      {isEmpty(data) ? (
        <Skeleton />
      ) : (
        <Widget description={data?.description || ''} title={data?.name || 'Untrusted Sources'}>
          {data?.defaultView === 'table' && (
            <Table
              rows={data?.data?.content?.map((row) => {
                return {
                  amount: row?.total,
                  source: row?.label,
                };
              })}
            />
          )}
        </Widget>
      )}
    </ErrorHandler>
  );
}
